import React, { Fragment,useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import TicketTable from "./TicketTable";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from '../../Common/Component/SearchTable';
const TicketHistory = () => {
  const [Large, setLarge] = useState(false);

  const LargeModaltoggle = () => setLarge(!Large);
  return (
    <Fragment>
      <Breadcrumbs
        parent="Support"
        subParent="Ticket History"
        mainTitle="Ticket History"
        span1={
          <FilterTable />
        }
        span3={<SearchTable/>}
      />
      <Container fluid={true} className="datatables">
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                <TicketTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TicketHistory;
